// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_PIP_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/is-editable.js